import request from '@/service/lib/request'

/**
 * 用户 - 登录
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 */
export function login(url, data) {
  return request({
    url,
    method: 'post',
    data
  })
}

/**
 * 用户 - 获取用户信息和权限
 */
export function getRole() {
  return request({
    url: '/api/v1/me',
    method: 'get'
  })
}

/**
 * 用户 - 退出
 */
export function logout(url) {
  return request({
    url: url,
    method: 'post'
  })
}

/**
 * 用户 - logo 信息
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 */
export function logo(id) {
  return request({
    url: `/api/v2/companies/${id}/logo`,
    method: 'get'
  })
}

export function resetPwd(data) {
  return request({
    url: `/api/v2/me/password`,
    method: 'PUT',
    data
  })
}
